module.exports = __webpack_public_path__ + "static/media/moderate.e4bbdf4a.svg";